/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Partner_Org_CtaInputs */



/**
* | output |
* | --- |
* | "Managed by partner" |
*
* @param {Pricing_Partner_Org_CtaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_partner_org_cta = /** @type {((inputs?: Pricing_Partner_Org_CtaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Partner_Org_CtaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vom Partner verwaltet")
	return /** @type {LocalizedString} */ ("Managed by partner")
});